import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

/**
 * Renders free text as Markdown so operator-written and AI-written text
 * (story requests, comments, investigation guidance…) shows formatted instead
 * of raw. Returns an HTML string for `[innerHTML]`, which Angular sanitises —
 * do not bypass that. `breaks: true` keeps plain-text line breaks, so text that
 * was never meant as Markdown still reads the way it was typed.
 *
 * Usage: `<div class="md-text" [innerHTML]="text | markdown"></div>`
 * (`.md-text` in scss/_markdown.scss styles the rendered elements).
 */
@Pipe({ name: 'markdown', standalone: false, pure: true })
export class MarkdownPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const text = (value ?? '').toString();
    if (!text.trim()) return '';
    try {
      return marked.parse(text, { async: false, breaks: true, gfm: true }) as string;
    } catch {
      return text;
    }
  }
}
